import { z } from "zod";
/**
 * A refund the card processor holds for a person to approve in its dashboard (GH-948): a Stripe
 * approval rule. Nothing has been refunded. Approved before `expiresAt`, the processor runs it and
 * the gift or order updates from its webhook; rejected or expired, nothing happens and staff may
 * ask again. `dashboardUrl` is the processor's page for the request, when it could be read.
 */
export const processorApprovalSchema = z.object({
    approvalRequestId: z.string().min(1).max(255),
    expiresAt: z.string().nullable(),
    dashboardUrl: z.string().url().nullable(),
});
//# sourceMappingURL=processor-approval.js.map